import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { TiretPipe } from 'src/app/pipe/tiret.pipe';
import { ParametreUtilisateurModel } from 'src/models/profil-utilisateur/parametre-utilisateur-model';
import { ProfilUtilisateurService } from 'src/services/profil-utilisateur.service';
import { UtilisateurService } from 'src/services/utilisateur.service';

@Component({
    selector: 'app-parametre-utilisateur',
    templateUrl: './parametre-utilisateur.component.html',
    styleUrls: ['./parametre-utilisateur.component.scss'],
    imports: [
        CommonModule,
        MatIcon,
        TranslateModule,
        MatProgressSpinner,
        TiretPipe
    ]
})
export class ParametreUtilisateurComponent implements OnInit {
  isLoading!: boolean;
  utilisateurId!: number;
  parametreUtilisateur!: ParametreUtilisateurModel;
  constructor(
    private location: Location,
    private utilisteurServicePilotage: UtilisateurService,
    private profilUtilisateurService: ProfilUtilisateurService) { }

  ngOnInit() {
    this.utilisateurId = this.utilisteurServicePilotage.selectionEntiteUtilisateur.entiteUtilisateurs[0].utilisateurId;
    this.obtenirParametreUtilisateur(this.utilisateurId);
  }

  private obtenirParametreUtilisateur(utilisateurId: number) {
    this.isLoading = true;
    this.profilUtilisateurService.obtenirParametreUtilisateur(utilisateurId).subscribe((reponse) => {
      this.parametreUtilisateur = reponse;
      this.isLoading = false;
    });
  }

   retour(): void {
    this.location.back();
  }

}
